import React from 'react';
import { Link } from 'react-router-dom';
import styles from '@/common/containers/EditQuestionsAnswers/styles.less';
import { Table } from '@/common/containers/EditQuestionsAnswers/components/index';
import { routes } from '@/app/routing/index';
import { getTaskModuleLabelKey } from '@/common/constants/constants';
import { useTranslation } from 'react-i18next';

const EditQuestionsAnswers = ({ module = '', disabledLegal = false }) => {
  const { t } = useTranslation();
  const moduleLabel = t(getTaskModuleLabelKey(module));
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h4 className={styles.headerTitle}>
          {t('{{module}} questionnaire', { module: moduleLabel })}
        </h4>
        {!disabledLegal && (
          <Link
            className={styles.headerLink}
            to={`${routes.dashboard.editQuestions}?module=${module}`}
          >
            {t('Edit Questionnaire')}
          </Link>
        )}
      </div>
      {disabledLegal && (
        <div className="note" style={{ marginTop: '24px' }}>
          {t(
            'The questionnaire will become available after all tasks are completed'
          )}
        </div>
      )}
      <Table module={module} />
    </div>
  );
};

export default EditQuestionsAnswers;
